<template>
  <button
    v-bind="$attrs"
    :type="type"
    :class="[
      'inline-flex size-9 shrink-0 items-center justify-center rounded-[1px] border border-transparent bg-transparent shadow-none transition focus-visible:ring-2 focus-visible:ring-black/15 focus-visible:outline-none enabled:active:translate-y-px disabled:pointer-events-none disabled:opacity-60',
      toneClass,
      hoverClass,
    ]"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(
  defineProps<{
    active?: boolean;
    tone?: 'black' | 'gray';
    type?: 'button' | 'submit' | 'reset';
  }>(),
  {
    active: false,
    tone: 'gray',
    type: 'button',
  },
);

const toneClass = computed(() => {
  if (props.active || props.tone === 'black') {
    return 'text-black';
  }

  return 'text-conference-muted';
});

const hoverClass = computed(() => {
  if (props.active) {
    return 'hover:border-black hover:bg-transparent';
  }

  if (props.tone === 'black') {
    return 'hover:border-black hover:bg-transparent hover:text-black';
  }

  return 'hover:border-black hover:bg-transparent hover:text-conference-muted';
});
</script>
